import { DatabaseEntities } from '../base';
import type { SqsEventType } from './types';

export const ENTITY_CRUD_EVENT_TYPES = {
  [DatabaseEntities.Appointment]: 'appointment.crud',
  [DatabaseEntities.Warehouse]: 'warehouse.crud',
  [DatabaseEntities.AssetVisit]: 'asset-visit.crud',
  [DatabaseEntities.Bol]: 'bol.crud',
  [DatabaseEntities.AssetVisitEvent]: 'asset-visit-event.crud'
} as const satisfies Partial<Record<DatabaseEntities, SqsEventType>>;

export type EntityCrudEventType =
  (typeof ENTITY_CRUD_EVENT_TYPES)[keyof typeof ENTITY_CRUD_EVENT_TYPES];

export function getEntityCrudEventType(entity: DatabaseEntities): EntityCrudEventType | undefined {
  return (ENTITY_CRUD_EVENT_TYPES as Partial<Record<DatabaseEntities, EntityCrudEventType>>)[
    entity
  ];
}
